import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { ReplaceUrlToToken } from '../store/actions';

function getUrl(route: ActivatedRouteSnapshot): string {
  return route.pathFromRoot.map((v) => v.url.map((segment) => segment.toString()).join('/')).join('/');
}

export const replaceUrlToTokenGuard: CanActivateFn = (route) => {
  const store = inject(Store);

  if (!route.params['isFinal']) {
    store.dispatch(
      new ReplaceUrlToToken({
        routerState: {
          url: getUrl(route),
          params: route.params,
          queryParams: route.queryParams,
        },
      }),
    );
  }

  return of(true);
};
